// extracted by mini-css-extract-plugin
export default {"nagbar":"styles_nagbar_ecdEL","nagbarItem":"styles_nagbar-item_Ltb3B","dot":"styles_dot_E3nUp"};